import {
  PRODUCT_REQUIREMENT_LIST_REQUEST,
  PRODUCT_REQUIREMENT_LIST_SUCCESS,
  PRODUCT_REQUIREMENT_LIST_FAIL,
  PRODUCT_REQUIREMENT_LIST_RESET,
  PRODUCT_REQUIREMENT_SINGLE_REQUEST,
  PRODUCT_REQUIREMENT_SINGLE_SUCCESS,
  PRODUCT_REQUIREMENT_SINGLE_FAIL,
  PRODUCT_REQUIREMENT_SINGLE_RESET,
  CREATE_PRODUCT_REQUIREMENT_REQUEST,
  CREATE_PRODUCT_REQUIREMENT_SUCCESS,
  CREATE_PRODUCT_REQUIREMENT_FAIL,
  CREATE_PRODUCT_REQUIREMENT_RESET,
  UPDATE_PRODUCT_REQUIREMENT_REQUEST,
  UPDATE_PRODUCT_REQUIREMENT_SUCCESS,
  UPDATE_PRODUCT_REQUIREMENT_FAIL,
  UPDATE_PRODUCT_REQUIREMENT_RESET,
  DELETE_PRODUCT_REQUIREMENT_REQUEST,
  DELETE_PRODUCT_REQUIREMENT_SUCCESS,
  DELETE_PRODUCT_REQUIREMENT_FAIL,
  DELETE_PRODUCT_REQUIREMENT_RESET,
} from "constants/productRequirementConstants";

export const listProductRequirementsReducer = (
  state = { productRequirementList: [] },
  action
) => {
  switch (action.type) {
    case PRODUCT_REQUIREMENT_LIST_REQUEST:
      return { loading: true };
    case PRODUCT_REQUIREMENT_LIST_SUCCESS:
      return { loading: false, productRequirementList: action.payload };
    case PRODUCT_REQUIREMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_REQUIREMENT_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const singleProductRequirementsReducer = (
  state = { productRequirementSingle: {} },
  action
) => {
  switch (action.type) {
    case PRODUCT_REQUIREMENT_SINGLE_REQUEST:
      return { loading: true };
    case PRODUCT_REQUIREMENT_SINGLE_SUCCESS:
      return { loading: false, productRequirementSingle: action.payload };
    case PRODUCT_REQUIREMENT_SINGLE_FAIL:
      return { loading: false, error: action.payload };
    case PRODUCT_REQUIREMENT_SINGLE_RESET:
      return [];
    default:
      return state;
  }
};

export const productRequirementCreateReducer = (
  state = { newProductRequirement: {} },
  action
) => {
  switch (action.type) {
    case CREATE_PRODUCT_REQUIREMENT_REQUEST:
      return { loading: true };
    case CREATE_PRODUCT_REQUIREMENT_SUCCESS:
      return { loading: false, newProductRequirement: action.payload };
    case CREATE_PRODUCT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_PRODUCT_REQUIREMENT_RESET:
      return { newProductRequirement: {} };
    default:
      return state;
  }
};

export const productRequirementUpdateReducer = (
  state = { updateProductRequirement: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_PRODUCT_REQUIREMENT_REQUEST:
      return { loading: true };
    case UPDATE_PRODUCT_REQUIREMENT_SUCCESS:
      return {
        loading: false,
        updateProductRequirement: action.payload,
        success: true,
      };
    case UPDATE_PRODUCT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_PRODUCT_REQUIREMENT_RESET:
      return { updateProductRequirement: {} };
    default:
      return state;
  }
};

export const productRequirementDeleteReducer = (
  state = { deleteProductRequirement: {} },
  action
) => {
  switch (action.type) {
    case DELETE_PRODUCT_REQUIREMENT_REQUEST:
      return { loading: true };
    case DELETE_PRODUCT_REQUIREMENT_SUCCESS:
      return {
        loading: false,
        deleteProductRequirement: action.payload,
        success: true,
      };
    case DELETE_PRODUCT_REQUIREMENT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_PRODUCT_REQUIREMENT_RESET:
      return { deleteProductRequirement: {} };
    default:
      return state;
  }
};
